import { GET_IVS_CHAT_ROOM_TOKEN } from "../../../../graphql/operations";
import { generateClient } from "@aws-amplify/api";

export const CHAT_CAPABILITY = {
  VIEW_MESSAGE: 'VIEW_MESSAGE',
  SEND_MESSAGE: 'SEND_MESSAGE',
  DISCONNECT_USER: 'DISCONNECT_USER',
  DELETE_MESSAGE: 'DELETE_MESSAGE'
};
export const CHAT_USER_ROLE = {
  VIEWER: 'VIEWER',
  SENDER: 'SENDER',
  MODERATOR: 'MODERATOR'
};

export const SEND_ERRORS = {
  RATE_LIMIT_EXCEEDED: 'rate limit exceeded',
  MAX_LENGTH_EXCEEDED: 'Message exceeds maximum length'
};

const client = generateClient();

const mapUserRoleToCapabilities = (userRole) => {
  switch (userRole) {
    case 'Admin':
      return [
        CHAT_CAPABILITY.VIEW_MESSAGE,
        CHAT_CAPABILITY.SEND_MESSAGE,
        CHAT_CAPABILITY.DELETE_MESSAGE,
        CHAT_CAPABILITY.DISCONNECT_USER
      ];
    case 'VIPuser':
      return [
        CHAT_CAPABILITY.VIEW_MESSAGE,
        CHAT_CAPABILITY.SEND_MESSAGE
      ];
    default:
      return [CHAT_CAPABILITY.VIEW_MESSAGE];
  }
};

export const requestChatToken = async (
  userRole
) => {
  try {
    const response = await client.graphql({
      query: GET_IVS_CHAT_ROOM_TOKEN,
    });

    const { roomToken, tokenExpirationTime } = response.data.getChatToken;
    const capabilities = mapUserRoleToCapabilities(userRole);
    return {
      token:roomToken,
      sessionExpirationTime: tokenExpirationTime,
      capabilities
    };
  } catch (error) {
    if (error.name === 'AbortError') {
      return { error };
    }
    console.error('Error requesting chat token:', error);
    return { error };
  }
};